export default {
  DOWNLOAD: 'Downloaden',
  PROCESSING: 'Verwerking',
  GENERAL_EVENT_INFO: 'Algemene informatie over het evenement',
  EVENT_DETAILS: 'details van het evenement',
  GENERATE_NEW: 'Genereer nieuwe',
  REPORT_NOT_GENERATED:
    'Uw rapport is nog niet gegenereerd of er zijn tot nu toe geen leads vastgelegd. Probeer het na enige tijd opnieuw.',
  REPORT_DOWNLOADED: 'Rapport Succesvol gedownload',
  DOWNLOAD_REPORT: 'Rapport downloaden',
  LAST_GENERATED: 'Laatste rapport gegenereerd op',
  DOWNLOAD_REPORT_INFO: 'Het genereren van een nieuw rapport kan even duren, dus houd dit tabblad open.'
}
